import DashboardCardLayout from '@/layouts/DashboardCardLayout.vue'
import AoDialogLayout from '@/layouts/AoDialogLayout.vue'
import AoFormDialogLayout from '@/layouts/AoFormDialogLayout.vue'
import AoPopupLayout from '@/layouts/AoPopupLayout.vue'
import AoPreviewLayout from '@/layouts/AoPreviewLayout.vue'

import AoCombobox from '@/components/ui/AoCombobox.vue'
import AoCheckboxes from '@/components/ui/AoCheckboxes.vue'
import AoRadioBtn from '@/components/ui/AoRadioBtn.vue'
import AoRadios from '@/components/ui/AoRadios.vue'
import AoRangeSliders from '@/components/ui/AoRangeSliders.vue'
import AoRangeDurationSliders from '@/components/ui/AoRangeDurationSliders.vue'
import AoSlider from '@/components/ui/AoSlider.vue'
import AoSelect from '@/components/ui/AoSelect.vue'
import AoSwitch from '@/components/ui/AoSwitch.vue'
import AoGreatDateRangePicker from '@/components/ui/AoGreatDateRangePicker.vue'
import AoGreatDatePicker from '@/components/ui/AoGreatDatePicker.vue'
import AoFileInput from '@/components/ui/AoFileInput.vue'
import AoColorInput from '@/components/ui/AoColorInput.vue'

import AoAsyncQueueProgress from '@/components/ui/AoAsyncQueueProgress.vue'
import AoLogoPreloader from '@/components/ui/AoLogoPreloader.vue'
import AoPreloaderOverlay from '@/components/ui/AoPreloaderOverlay.vue'
import AoDraggableCheckboxes from '@/components/ui/AoDraggableCheckboxes.vue'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import AoExpansionPanel from '@/components/ui/AoExpansionPanel.vue'
import AoTooltip from '@/components/ui/AoTooltip.vue'
import AoGroupbox from '@/components/ui/AoGroupbox.vue'

import PopupWrapper from '@/components/ui/popups/PopupWrapper.vue'
import PopupActions from '@/components/ui/popups/PopupActions.vue'
import PopupHeader from '@/components/ui/popups/PopupHeader.vue'
import PopupPhoto from '@/components/ui/popups/PopupPhoto.vue'

import AoCarousel from '@/components/ui/AoCarousel.vue'

export function registerGlobalComponents(app) {
	// Layouts
	app
		.component('ao-dashboard-card-layout', DashboardCardLayout)
		.component('ao-dialog-layout', AoDialogLayout)
		.component('ao-form-dialog-layout', AoFormDialogLayout)
		.component('ao-popup-layout', AoPopupLayout)
		.component('ao-preview-layout', AoPreviewLayout)

	// Forms
	app
		.component('ao-combobox', AoCombobox)
		.component('ao-checkboxes', AoCheckboxes)
		.component('ao-radio-btn', AoRadioBtn)
		.component('ao-radios', AoRadios)
		.component(AoRangeSliders.name, AoRangeSliders)
		.component(AoRangeDurationSliders.name, AoRangeDurationSliders)
		.component('ao-slider', AoSlider)
		.component('ao-select-legacy', AoSelect)
		.component('ao-switch', AoSwitch)
		.component('ao-great-date-range-picker', AoGreatDateRangePicker)
		.component('ao-great-date-picker', AoGreatDatePicker)
		.component('ao-file-input', AoFileInput)
		.component('ao-color-input', AoColorInput)

	app
		.component('ao-async-queue-progress', AoAsyncQueueProgress)
		.component('ao-logo-preloader', AoLogoPreloader)
		.component('ao-preloader-overlay', AoPreloaderOverlay)
		.component('ao-draggable-checkboxes', AoDraggableCheckboxes)
		// TODO: rename to ao-confirm-dialog
		.component('confirm-dialog', ConfirmDialog)
		.component('ao-expansion-panel', AoExpansionPanel)
		.component(AoTooltip.name, AoTooltip)
		.component('ao-groupbox', AoGroupbox)

	// Popup
	app
		.component(PopupWrapper.name, PopupWrapper)
		.component(PopupActions.name, PopupActions)
		.component(PopupHeader.name, PopupHeader)
		.component(PopupPhoto.name, PopupPhoto)

	// Other
	app
		.component('ao-carousel', AoCarousel)
}
